// The board's cursor (the retest of issue 1371): one answer, read from the board modes as they are NOW, never from what
// a listener last heard. The cursor sits on the board's host element, which outlives each build of the board; a rebuild
// (looking through somebody's eyes changes who the board is drawn for) dropped the old listeners, a mode ended in the gap
// (View as ends drawing) and nobody was listening to put the cursor back, so the crosshair stayed. Binding reads the
// modes at once, follows every change, and unbinding puts the default cursor back.
import { areaTool } from './areaTool';
import { drawTool } from './drawTool';
import { focusTool } from './focusTool';
import { fogTool } from './fogTool';
import { measureTool } from './measureTool';
import { targetTool } from './targetTool';
import { wallTool } from './wallTool';
import { whatsThisTool } from './whatsThisTool';
import { zoneTool } from './zoneTool';

/** The cursor over the board for the modes on now; '' is the browser's own arrow. Walls, zones and the fog are the DM's. */
export function boardCursor(isDm: boolean): string {
  const d = drawTool.get();
  if (d.on) return d.mode === 'erase' ? 'pointer' : d.mode === 'text' ? 'text' : d.mode === 'stamp' ? 'copy' : 'crosshair';
  if (whatsThisTool.get().on) return 'help';
  if (targetTool.get().on) return 'crosshair';
  if (isDm && wallTool.get().on) return 'crosshair';
  if (isDm && (zoneTool.get().on || fogTool.get().on)) return 'cell';
  if (focusTool.get().on || measureTool.get().on) return 'crosshair';
  if (areaTool.get().on) return 'copy';
  return '';
}

/** Keeps `el`'s cursor on {@link boardCursor} from now on; the returned function stops that and leaves the arrow. */
export function bindBoardCursor(el: HTMLElement, isDm: boolean): () => void {
  const apply = () => { el.style.cursor = boardCursor(isDm); };
  const offs = [drawTool, whatsThisTool, targetTool, wallTool, zoneTool, fogTool, focusTool, measureTool, areaTool]
    .map((tool) => (tool.subscribe as (l: () => void) => () => void)(apply));
  apply();
  return () => { for (const off of offs) off(); el.style.cursor = ''; };
}
